import React, { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import { formatNumber } from '../../../utils/DefaultFunction';

const ApiCallsChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current && data?.length) {
      Highcharts.chart(chartRef.current, {
        chart: {
          type: 'areaspline', 
          backgroundColor: 'white',
          height: 200,
          margin: [10, 0, 30, 0],
          spacing: [0, 0, 0, 0],
        },

        title: { text: null },
        credits: { enabled: false },
        legend: { enabled: false },

        xAxis: {
          categories: data.map(d => d._id),
          lineWidth: 0,
          tickLength: 0,
          labels: { style: { fontSize: '10px', color: '#64748b' } }
        },

        yAxis: { visible: false, title: { text: null } },

        plotOptions: {
          areaspline: {
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, 'rgba(74, 144, 226, 0.25)'],
                [1, 'rgba(74, 144, 226, 0.02)']
              ]
            },
            lineColor: '#4A90E2',
            lineWidth: 2,
            marker: { enabled: false }
          }
        },

        tooltip: {
          useHTML: true,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderWidth: 1,
          borderColor: '#ccc',
          shadow: false,
          formatter: function () {
            const point = data[this.point.index]; // find API stats for this date
            return `
              <b>${this.x}</b><br/>
              <span style="color:#4A90E2">●</span> Total: <b>${formatNumber(point.total_message)}</b><br/>
              <span style="color:#00a63e">●</span> Accepted: <b>${formatNumber(point.accepted)}</b><br/>
              <span style="color:#e7000b">●</span> Rejected: <b>${formatNumber(point.rejected)}</b>
            `;
          }
        },

        series: [
          {
            pointPlacement: 'on' ,
            name: 'Total Messages',
            data: data.map(d => d.total_message),
            color: '#4A90E2'
          }
        ]
      });
    }
  }, [data]);

  return <div ref={chartRef} className="w-full" />;
};

export default ApiCallsChart;
